<template>
  <div class="position-relative" :style="{minHeight: loaded ? undefined : '12rem'}">
    <BootstrapAlert v-if="block.value.context_message" variant="warning" dismissible>
      {{ block.value.context_message }}
    </BootstrapAlert>
    <section
      v-if="loaded === false"
      class="position-absolute d-flex justify-content-center align-items-center"
      style="inset: 0; z-index: 1"
    >
      <AsciiSpinner class="fs-5" />
    </section>
    <BootstrapAlert v-if="errorMessage" variant="danger">{{ errorMessage }}</BootstrapAlert>
    <section
      :id="block.value.report_id"
      class="report"
      :style="[
        'background: transparent; color-scheme: auto',
        {visibility: loaded ? 'visible' : 'hidden'},
      ]"
    ></section>
  </div>
</template>
<script lang="ts" setup>
import {SphereBlock} from '@/stores/apolloPlatform/cores/portalNavigation';
import {useReportEmbed} from '@/composables/useReportEmbed';

const {block} = defineProps<{block: SphereBlock<'report_block'>}>();
const {isMobile} = useBsBreakpoints();

const {loaded, errorMessage} = useReportEmbed(block.value.report_id, block.value, isMobile);
</script>
